import React, {useState} from 'react';
import './info-card.css'

const InfoCard = ({title="Title", text="Add Card Text"})=> {

    return (
        <div className="card-wrapper">
            <div className="card-title center">
                {title}
            </div>
            <div className="card-body parallax">
                <p className='card-text sliding-container'>
                    {text}
                </p>
            </div>
        </div>
    )
}

export default InfoCard;
